import React from 'react';
import { useAppStore } from '../App';

interface Props {
 info: {
  adminName: string;
  startedAt: string;
 };
}

const ViewedByAdminAlert: React.FC<Props> = ({ info }) => {
 const { dismissViewedByAdmin } = useAppStore();
 const startedAt = info.startedAt ? new Date(info.startedAt).toLocaleString() : '';

 return (
  <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4">
   <div className="bg-white max-w-md w-full p-6 shadow-xl">
    <div className="flex items-start gap-3">
     <div className="text-2xl">🛡️</div>
     <div className="flex-1">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">관리자 view-as 알림</h3>
      <p className="text-sm text-gray-700 mb-2">
       관리자 <strong>{info.adminName}</strong> 님이 현재 귀하의 계정으로 view-as 진입 중입니다.
      </p>
      {startedAt && <p className="text-xs text-gray-500 mb-3">시작: {startedAt}</p>}
      <ul className="text-xs text-gray-600 list-disc list-inside space-y-1 mb-4">
       <li>관리자는 <strong>읽기 전용</strong>으로만 조회할 수 있습니다</li>
       <li>메시지함·채팅 내용은 열람 불가</li>
       <li>모든 진입/종료는 audit log 에 기록됨</li>
       <li>프로필 페이지에서 진입 이력을 확인할 수 있습니다</li>
      </ul>
     </div>
    </div>
    <div className="flex justify-end gap-2 mt-4">
     <a
      href="/policy/admin-access"
      target="_blank"
      rel="noopener"
      className="text-sm text-blue-600 hover:underline self-center"
     >
      정책 보기
     </a>
     <button
      onClick={dismissViewedByAdmin}
      className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-1.5 text-sm"
     >
      확인
     </button>
    </div>
   </div>
  </div>
 );
};

export default ViewedByAdminAlert;
